export default {
  'loanAccountDetails.generalInfoKey': 'generalInformation',
  'loanAccountDetails.generalInfoValue': 'General Information'
};
